import React, { useState, useEffect, useRef } from 'react';
import { HiChevronDown, HiCash, HiCreditCard } from 'react-icons/hi';
import { formatPKR } from '../utils/currencyFormatter';
import './AccountSelect.css';

/**
 * Styled dropdown for selecting Cash or Bank account in payment splits.
 */
const AccountSelect = ({
  accounts = [],
  value,
  onChange,
  placeholder = 'Select account',
  disabled,
  id
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const selectedAccount = accounts.find(a => String(a.id) === String(value));

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="account-select" ref={containerRef} id={id}>
      <button
        type="button"
        className={`account-select-trigger ${open ? 'open' : ''} ${disabled ? 'disabled' : ''}`}
        onClick={() => !disabled && setOpen(!open)}
        disabled={disabled}
      >
        <span className="account-select-value">
          {value && selectedAccount ? (
            <>
              <span className="account-select-icon">
                {selectedAccount.type === 'cash' ? <HiCash /> : <HiCreditCard />}
              </span>
              <span className="account-select-label">
                <span className="account-select-name">{selectedAccount.name}</span>
                <span className="account-select-meta">
                  {selectedAccount.type === 'cash' ? 'Cash' : (selectedAccount.bank_name || 'Bank')} · {formatPKR(selectedAccount.current_balance ?? selectedAccount.currentBalance)}
                </span>
              </span>
            </>
          ) : (
            <span className="account-select-placeholder">{placeholder}</span>
          )}
        </span>
        <HiChevronDown className="account-select-chevron" />
      </button>

      {open && (
        <div className="account-select-dropdown">
          <div className="account-select-list">
            {accounts.length === 0 ? (
              <div className="account-select-empty">No accounts</div>
            ) : (
              accounts.map(acc => {
                const isSelected = String(acc.id) === String(value);
                return (
                  <button
                    key={acc.id}
                    type="button"
                    className={`account-select-option ${isSelected ? 'selected' : ''}`}
                    onClick={() => {
                      onChange(acc.id);
                      setOpen(false);
                    }}
                  >
                    <span className="account-select-icon">
                      {acc.type === 'cash' ? <HiCash /> : <HiCreditCard />}
                    </span>
                    <span className="account-select-option-content">
                      <span className="account-select-option-name">{acc.name}</span>
                      <span className="account-select-option-meta">
                        {acc.type === 'cash' ? 'Cash' : (acc.bank_name || 'Bank')} · {formatPKR(acc.current_balance ?? acc.currentBalance)}
                      </span>
                    </span>
                  </button>
                );
              })
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AccountSelect;
